import { injectable, ITeaContribution } from '@meego-remote/core/app/contract';
import { getAPIHost, isTrialDemoEnvironment } from './utils';
import { isVa } from '@meego-remote/main/base/utils';

@injectable({ implements: [ITeaContribution] })
export class TrialDemoTeaContribution implements ITeaContribution {
  genHeaders(): Record<string, unknown> {
    if (!isTrialDemoEnvironment()) {
      return {};
    }
    let trialDemoSimpleName = sessionStorage.getItem('trial_demo_simple_name');
    if (!trialDemoSimpleName) {
      trialDemoSimpleName = window.location.pathname.split('/')?.[1];
    }
    const meegoTrialData = JSON.parse(
      localStorage.getItem(`meego_trial_data_${trialDemoSimpleName}`) || '{}',
    );
    const customRequestHeader: Record<string, unknown> = {
      'X-Meego-Trial-Template-Id': meegoTrialData?.templateId,
      'X-Meego-Trial-Visitor-Id': meegoTrialData?.visitorId,
    };
    if (isVa) {
      customRequestHeader['meego_target_unit'] = 'larksgaws';
    }
    return {
      custom_request_header: customRequestHeader,
      report_url: `https://${getAPIHost(location.host)}/goapi/v1/event/record`,
    };
  }
}
